/*
	Column tests
	percentToColumn([{ coreColumn: { attrs: { width: 20 } } }, { coreColumn: {} }, { coreColumn: { attrs: { width: 20 } } }])
	20, (60), 20          = 2, 7, 2         ---> 2, 8, 2 !!!!

	percentToColumn([{ coreColumn: { attrs: { width: 33.33 } } }, { coreColumn: { attrs: { width: 33.33 } } }, { coreColumn: { attrs: { width: 33.33 } } }])
	33.33, 33.33, 33.33   = 4, 4, 4

	percentToColumn([{ coreColumn: { attrs: { width: 12 } } }, { coreColumn: { attrs: { width: 3 } } }, { coreColumn: {} }, { coreColumn: { attrs: { width: 38 } } }])
	12, 3, (35), 38       = 3, 0, 4, 5

	percentToColumn([{ coreColumn: { attrs: { width: 10 } } }, { coreColumn: {} }, { coreColumn: {} }, { coreColumn: { attrs: { width: 10 } } }])
	10, (40), (40), 10    = 1, 5, 5, 1

	percentToColumn([{ coreColumn: { attrs: { width: 10 } } }, { coreColumn: {} }, { coreColumn: {} }])
	10, (45), (45)        = 1, 6, 6         ---> 0, 6, 6 !!!!

	percentToColumn([{ coreColumn: { attrs: { width: 20 } } }, { coreColumn: { attrs: { width: 20 } } }, { coreColumn: { attrs: { width: 20 } } }, { coreColumn: { attrs: { width: 20 } } }, { coreColumn: { attrs: { width: 20 } } }])
	20, 20, 20, 20, 20    = 2, 2, 2, 2, 2   ---> 2, 2, 2, 2, 2 !!!! (10 columns)

	percentToColumn([{ coreColumn: { attrs: { width: 21 } } }, { coreColumn: { attrs: { width: 21 } } }, { coreColumn: { attrs: { width: 21 } } }, { coreColumn: { attrs: { width: 21 } } }, { coreColumn: { attrs: { width: 16 } } }])
	21, 21, 21, 21, 16    = 3, 3, 3, 3, 2   ---> 3, 3, 3, 3

	percentToColumn([{ coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 10 } } }])
	30, 30, 30, 10        = 4, 4, 4, 1      ---> 4, 4, 4 !!!!

	percentToColumn([{ coreColumn: { attrs: { width: 10 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }])
	10, 30, 30, 30        = 1, 4, 4, 4      ---> 4, 4, 4 !!!!

	percentToColumn([{ coreColumn: { attrs: { width: 5 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 30 } } }, { coreColumn: { attrs: { width: 5 } } }])
	5, 30, 30, 30, 5      = 1, 4, 4, 4, 1   ---> 4, 4, 4 !!!!

	To fix anomalies group by most common number
	Largest most common number is to remain the same. i.e. 2, 5, 5, 2 ---> 1, 5, 5, 1
	Least common number to increase/decrease so that we get to 12 or less.
*/

const percentToColumn = (sections) => {
	let emptyColumns = 0;
	let totalSpecifiedColumnWidth = 12;
	let initialColumnWidths = [];

	// Figure out column widths here.
	initialColumnWidths = sections.map((column) => {
		const width = column?.coreColumn?.attrs?.width || null;
		let columnWidth = null;

		if (width && width.indexOf('px') === -1) {
			columnWidth = Math.round(parseInt(width, 10) * 0.12);
			totalSpecifiedColumnWidth -= columnWidth;
		} else if (width) {
			columnWidth = 'x';
		} else emptyColumns += 1;

		return columnWidth;
	});

	if (emptyColumns) {
		// Automatically fill remaining columns
		initialColumnWidths = initialColumnWidths.map((column) => (column === null ? Math.round(totalSpecifiedColumnWidth / emptyColumns) : column));
		// console.log('DEBUG: emptyColumns - initialColumnWidths', initialColumnWidths);
	}

	// Total column width adjust up or down to fill 12 columns
	const totalColumnWidth = initialColumnWidths.reduce((acc, column) => acc + column, 0);

	// console.log('DEBUG: totalColumnWidth', totalColumnWidth);

	// Too many columns or not enough
	if (totalColumnWidth > 12 || totalColumnWidth < 12) {
		const groupedColumns = initialColumnWidths.reduce((acc, column) => {
			if (!acc[column]) return { ...acc, [column]: 1 };
			return { ...acc, [column]: acc[column] + 1 };
		}, {});

		// console.log('DEBUG: groupedColumns', groupedColumns);

		// Sort by least common. Returns array with key.
		const leastCommon = Object.keys(groupedColumns).sort((a, b) => (groupedColumns[a] > groupedColumns[b] ? -1 : 1)).slice(-1);
		const totalColumnsToChange = groupedColumns[leastCommon[0]];

		// console.log('DEBUG: leastCommon', leastCommon);

		if (totalColumnWidth > 12) {
			const perColumnShift = Math.ceil((totalColumnWidth - 12) / totalColumnsToChange); // how much to decrease each column by.
			initialColumnWidths = initialColumnWidths.map((column) => (column === parseInt(leastCommon[0], 10) ? column - perColumnShift : column));
		} else {
			const perColumnShift = Math.floor((12 - totalColumnWidth) / totalColumnsToChange); // how much to increase each column by.
			initialColumnWidths = initialColumnWidths.map((column) => (column === parseInt(leastCommon[0], 10) ? column + perColumnShift : column));
		}
	}

	return initialColumnWidths;
};

export { percentToColumn };
export default percentToColumn;
